import { Component, OnInit } from '@angular/core'
import { AuthService } from '../../shared/auth.service'
import { Router } from '@angular/router'
import { GlobService } from 'src/app/shared/glob.service'
import { AjaxService } from 'src/app/shared/ajax.service'
import { PageService } from '../../page/page.service'

@Component({
  selector: 'app-headerbar',
  templateUrl: './headerbar.component.html'
})
export class HeaderbarComponent implements OnInit {

  constructor(public glob: GlobService, public authService: AuthService, private router: Router, private ajax: AjaxService, private pservice: PageService) { }
  // glob: any = this.glob
  ctitle: string

  ngOnInit() {
  }

  logout() {
    this.authService.logout(() => {
      this.router.navigate([`/account/login`])
    })
  }

  emode_changer() {
    this.glob.emode = !this.glob.emode
    this.ctitle = this.glob.config.tit
  }

  dmode_changer() {
    this.glob.dmode = !this.glob.dmode
  }

  hmode_changer() {
    this.glob.hmode = !this.glob.hmode

    let t: any = $('*[data-toggle="tooltip"]')
    t.tooltip(this.glob.hmode ? 'enable' : 'disable')
  }

  upd_config(key: string, val: any) {
    this.ajax.execute({
      url: 'config/upd',
      data: { key, val },
      success: (post: any) => {
        this.glob.config[key] = val
        this.glob.emode = false
      }
    })
  }

  logo_brows() {
    document.getElementById('logo_brows').click()
  }

  logo_fetch(event) {
    var uploadData = new FormData()
    uploadData.append('file', event.target.files[0])
    this.ajax.execute({
      url: 'config/logo_set',
      data: uploadData,
      type: 'post',
      contentType: false,
      processData: false,
      success: () => {
        document.getElementById('headerbar_logo')['src'] = document.getElementById('headerbar_logo')['src'] + '?t=' + new Date().getTime()
      }
    })
  }

  devmode() {
    return this.authService && this.authService.profile && this.authService.profile.role_id == '2019010208414614691'
  }

  initial_theme(nam) {
    this.glob.themer(nam)

    // for(let echart of this.pservice.components.charts)
    // {
    //   console.log(5006000, echart)
    //   echart.service.com.themer(echart.model)
    // }
  }

}
